"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("@/utils");

//
//
//
//
//
//
//
//
var _default = {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    isExternalLink: function isExternalLink(routePath) {
      return (0, _utils.isExternal)(routePath);
    },
    linkProps: function linkProps(url) {
      if (this.isExternalLink(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        };
      }

      return {
        is: 'router-link',
        to: url
      };
    }
  }
};
exports.default = _default;